import { EMPTY_OBJECT } from '../../../constants/common'
import { Avatar, AVATAR_HEIGHT_32 } from '../../Avatar'
import { FloatingTooltip } from '../../Floating'

import * as styles from './SelectEntityItemAvatar.module.css'

function SelectEntityItemAvatar({
  Icon,
  avatar,
  avatarClassName = styles.avatar,
  iconProps,
  iconSize,
  iconTooltip,
  size = AVATAR_HEIGHT_32,
}) {
  const { Icon: AvatarIcon, ...avatarProps } = avatar ?? EMPTY_OBJECT

  return (
    <FloatingTooltip content={iconTooltip}>
      <Avatar
        {...avatarProps}
        Icon={Icon || AvatarIcon}
        className={avatarClassName}
        iconProps={iconProps}
        iconSize={iconSize}
        size={size}
      />
    </FloatingTooltip>
  )
}

export default SelectEntityItemAvatar
